
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

@Component({
    selector: 'emoji-type',
    templateUrl: './emoji-type.component.html',
    styleUrls: ['./emoji-type.component.css'],
})
export class EmojiTypeComponent implements OnInit {

    //self explanatory

    @Input() question_index: number;
    @Input() question_name: string;
    @Input() question_name_second: string;
    @Input() question_max_char: number;
    @Input() is_mandt: boolean;
    @Input() userRes : string[];
    @Input() question_number: number;
    @Output() user_Resp = new EventEmitter<string[]>();
    @Input() indexOfRepeater: number;

    response: string;
    options: any[];
    text: string;

    constructor() {

    }
   
    ngOnInit() {
        this.text = '';
        this.options = [
        { clicked: '../../../assets/images/icon_rating_1_clicked.svg' , emoji: '../../../assets/images/icon_rating_1.svg' ,text:'Sucks big time'},
        { clicked: '../../../assets/images/icon_rating_2_clicked.svg' , emoji: '../../../assets/images/icon_rating_2.svg',text:'Kinda bad'},
        { clicked: '../../../assets/images/icon_rating_3_clicked.svg', emoji: '../../../assets/images/icon_rating_3.svg' ,text:'Meh'},
        { clicked: '../../../assets/images/icon_rating_4_clicked.svg', emoji: '../../../assets/images/icon_rating_4.svg',text:'Pretty Good' },
        { clicked: '../../../assets/images/icon_rating_5_clicked.svg', emoji: '../../../assets/images/icon_rating_5.svg' ,text:'Rocks!'}];
        // this.response = this.userRes[this.indexOfRepeater];
    }
    changed(i: number) {
        for (let j = 0; j < this.options.length; j++) {
            var element = document.getElementById('image' + j);           
            if(i == j)
            {
                element['src'] = this.options[j].clicked;  
                this.text = this.options[i].text;
            }
            else
            {
                element['src'] = this.options[j].emoji;     
            }
        }
        this.response = this.text;
        this.user_Resp.emit([this.indexOfRepeater.toString(),this.question_number.toString(),this.response]);
    }
}



// WEBPACK FOOTER //
// ./src/app/questions-type/emoji-type/emoji-type.component.ts